<template>
  <ValidationProvider v-slot="{ errors, valid }" :name="label" :rules="rules">
    <BaseField
      :label="label"
      :label-for="$attrs.id"
      :type="{ 'is-danger': errors[0], '': valid }"
      :message="errors"
    >
      <div class="control is-expanded">
        <span class="select is-fullwidth is-small">
          <region-select
            v-model="currentValue"
            v-bind="$attrs"
            :region="currentValue"
            :usei18n="false"
            autocomplete
          />
        </span>
      </div>
    </BaseField>
  </ValidationProvider>
</template>

<script>
import BaseField from './BaseField'
import BaseFieldMixin from './BaseFieldMixin'

export default {
  components: {
    BaseField,
  },
  mixins: [BaseFieldMixin],
  inheritAttrs: false,
}
</script>
